import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import persianJs from 'persianjs'

import services from 'core/services';
import { PureComponent, Form, GroupBox } from 'core/components';
import { withLocale } from 'core/decorators';
import { Row, ListInput, List, Icon, Button, Col, CardContent } from 'core/components/Framework7';
import { addAddress, editAddress } from 'core/module/operations';

import classes from './styles.module.css';
import MapBox from 'core/components/map-component/Map';
import initLocation from 'core/components/map-component/js-files';

const NumericInput = Form.NumericInput;

class AddressForm extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      isNew: props.id == "new",
      item: props.item,
      provinces: [],
      cities: [],
      name: '',
      phone: '',
      address: '',
      provinceId: null,
      cityId: null,
      province: null,
      city: null,
      location: {
        lat: 35.6986233376445,//عرض جغرافیایی
        lng: 51.33745962730384,//طول جغرافیایی
        zoom: 14
        // lat: 30.35495328204977,//عرض جغرافیایی
        // lng: 48.26603328499122,//طول جغرافیایی
        // zoom: 13
      }
    }
  }

  static get defaultProps() {
    return {
      item: null,
    }
  }

  componentDidMount() {
    const { isNew } = this.state;
    const params = {
      store: 2
    }

    services.ecommerce.Province.getProvinces(params)
      .then(r => {
        this.setState({
          provinces: r.data.provinces,
          province: r.data.provinces[0],
          provinceId: r.data.provinces[0].id,
          city: r.data.provinces[0].cities[0],
          cityId: r.data.provinces[0].cities[0].id,
        }, () => {
          if (!isNew) {
            this.getData()
          }
        })
      })
      .catch(err => {
        // show error dialog
      })
      .finally(() => {
        // close dialog
      })
  }

  getData() {
    const { id } = this.props;
    const params = {
      store: 2
    }

    services.ecommerce.Address.getAddress(id, params)
      .then(r => {
        this.handleInitialValue(r.data.addresses)
      })
      .catch(err => {
        // show error dialog
      })
      .finally(() => {
        // close dialog
      })
  }

  handleInitialValue(data) {
    const address = data.address

    console.log('address:', address);
    const o = this.findProvinceCity(address ? address.cityId : null);

    // console.log(data.address);
    // console.log("addreess");
    const defaultLocation = { ...this.state.location };

    this.setState({
      name: address ? address.title : null,
      phone: address ? address.phone ? address.phone.number : null : null,
      address: address ? address.text : null,
      provinceId: address ? address.city ? address.city.provinceId : null : null,
      cityId: address ? address.cityId : null,
      province: o.province, // dont use address.city.province, it doesnt have any cities, they will use in city map
      city: address ? address.city : null,
      location: address.location ? {
        lat: address.location?.latitude,
        lng: address.location?.longitude,
        zoom: address.location?.zoom
      } : defaultLocation
    });

    // console.log(this.state.location);
    // console.log("state");
  }

  findProvinceCity(cityId) {
    if (!cityId) return

    const { provinces } = this.state

    for (const province of provinces) {
      for (const city of province.cities) {
        if (city.id == cityId)
          return { province: province, city: city }
      }
    }
  }

  changeName(e) {
    // console.log('name changed => from', this.state.name, e.target.value)
    this.setState({
      name: String(e.target.value),
    })
  }

  changeProvince(e) {
    // console.log('province changed => from', this.state.provinceId, e.target.value);

    const { provinces } = this.state;
    if (!provinces) return

    const selectedProvince = provinces.find(f => f.id == e.target.value);

    this.setState({
      provinceId: e.target.value,
      province: selectedProvince,

    });
  }

  changeCity(e) {
    // console.log('city changed => from', this.state.cityId, e.target.value)
    this.setState({
      cityId: e.target.value,
      // location: {
      //   lat: 35.749648,//عرض جغرافیایی
      //   lng: 51.32660035,//طول جغرافیایی
      //   zoom: 18
      // }
    })
  }

  changePhone(e) {
    if (!e.target.value || e.target.value == "") {
      this.setState({
        phone: ''
      })

      return
    }

    this.setState({
      phone: persianJs(e.target.value).toEnglishNumber().toString()
    })
  }

  changeLocation(locationObject) {
    const { lat, lng, zoom } = locationObject;
    // console.log("biroon state");
    // console.log("changeLocation:", locationObject);
    this.setState({
      location: {
        lat: lat,
        lng: lng,
        zoom: zoom
      }
    })
  };


  findMyLocation(lat, lng, zoom) {
    // console.log("findMyLocation:", lat);

    this.setState({
      location: {
        lat: lat,
        lng: lng,
        zoom: zoom
      }
    })
  }

  changeAddress(e) {
    this.setState({
      address: e.target.value
    })
  }

  handleSubmit() {
    const { id } = this.props;
    const { isNew, name, cityId, phone, address, location } = this.state;

    const params = {
      store: 2
    }

    if (!name || !address) return

    const model = {
      cityId: Number(cityId),
      phone: {
        area: "",
        countryCode: "98",
        number: phone
      },
      postal_code: "",
      text: address,
      location: {
        latitude: location.lat,
        longitude: location.lng,
        zoom: location.zoom
      },
      title: name,
    }

    this.$f7.dialog.preloader('در حال ارسال اطلاعات');

    if (isNew) return this.props.addAddress(model, params).then(r => { this.props.navigate.back() }).finally(r => { this.$f7.dialog.close(); })

    return this.props.editAddress(id, model, params).then(r => { this.props.navigate.back() }).finally(r => { this.$f7.dialog.close(); })
  }

  renderProvinceOption() {
    const { provinces } = this.state;

    if (!provinces) return

    return provinces.map(province => {
      return (
        <option key={province.id} value={province.id}>{province.name}</option>
      )
    })
  }

  renderCityOption() {
    const { province } = this.state;
    if (!province || !province.cities) return

    // console.log('province:', province, 'province.cities:', province.cities);

    return province.cities.map(city => {
      return (
        <option key={city.id} value={city.id}>{city.name}</option>
      )
    })
  }

  onSubmit(e) {
    e.preventDefault();
  }

  hasError() {
    const { address, name, provinceId, cityId } = this.state;
    return !(provinceId && cityId && (name.length >= 2) && (address.length >= 4))
  }

  render() {
    const { address, name, phone, provinceId, cityId, location } = this.state;
    // console.log('province:', provinceId)
    // console.log('city:', cityId)

    return (
      <form action="" onSubmit={this.onSubmit} className={classes.container}>
        <div className={`${classes.pagePadding}`}>
          <GroupBox outline title='آدرس گیرنده'>
            <CardContent>
              <List noHairlinesMd>
                <ListInput
                  type="text"
                  value={name}
                  placeholder="عنوان"
                  clearButton
                  required
                  validate
                  info={'اجباری، مانند خانه یا محل کار'}
                  errorMessage={'لطفا عنوان آدرس گیرنده را وارد کنید'}
                  onInputClear={() => this.setState({ name: '' })}
                  onChange={this.changeName}
                  className={classes.input}
                >
                  <Icon icon='mdi-subtitles' slot="media" />
                </ListInput>
                <ListInput
                  type="select"
                  value={provinceId || ''}
                  placeholder="استان"
                  // clearButton
                  required
                  validate
                  info={'اجباری، استان مقصد'}
                  errorMessage={'لطفا استان مقصد را وارد کنید'}
                  onChange={this.changeProvince}
                  className={classes.input}
                >
                  <Icon icon='mdi-home-group' slot="media" />
                  {this.renderProvinceOption()}
                </ListInput>
                <ListInput
                  type="select"
                  value={cityId || ''}
                  placeholder="شهر"
                  // clearButton
                  required
                  validate
                  info={'اجباری، شهر مقصد'}
                  errorMessage={'لطفا شهر مقصد را وارد کنید'}
                  onChange={this.changeCity}
                  className={classes.input}
                >
                  <Icon icon='mdi-home-city' slot="media" />
                  {this.renderCityOption()}
                </ListInput>
                <ListInput
                  type="tel"
                  clearButton
                  value={phone}
                  placeholder="تلفن"
                  info={'شماره تلفن گیرنده'}
                  onInputClear={() => this.setState({ phone: '' })}
                  onChange={this.changePhone}
                  className={classes.input}
                >
                  <Icon icon='mdi-phone' slot="media" />
                </ListInput>
                <ListInput
                  type="textarea"
                  value={address}
                  placeholder="آدرس"
                  clearButton
                  required
                  validate
                  info={'اجباری، آدرس تحویل گیرنده'}
                  errorMessage={"لطفا آدرس تحویل گیرنده را وارد کنید"}
                  onInputClear={() => this.setState({ address: '' })}
                  onChange={this.changeAddress}
                  className={classes.input}
                >
                  <Icon icon='mdi-map-marker' slot="media" />
                </ListInput>


                <div className="">
                  <MapBox
                    locationValue={initLocation.init(location?.lat, location?.lng, location?.zoom)}
                    handleChangeLocation={this.changeLocation}
                    handleFindMyLocation={this.findMyLocation}

                  />
                </div>
              </List>
            </CardContent>
          </GroupBox>
        </div>
        <Button large fill
          type='submit'
          icon="mdi-map-marker-check"
          text={'ثبت اطلاعات'}
          className={classes.fullWidthButton}
          disabled={this.hasError()}
          onClick={this.handleSubmit}
        />
      </form>
    )
  }
}

export default connect(
  state => ({
    user: state.General.user
  }),
  {
    addAddress,
    editAddress
  }
)(withLocale('address_form')(autobind(AddressForm)))
